"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Translates strings.
 */

var TypeHandlerString =
/*#__PURE__*/
function () {
  function TypeHandlerString() {
    _classCallCheck(this, TypeHandlerString);
  }

  _createClass(TypeHandlerString, [{
    key: "fromRdf",
    value: function fromRdf(literal) {
      return literal.value;
    }
  }, {
    key: "toRdf",
    value: function toRdf(value, dataFactory) {
      return dataFactory.literal(value);
    }
  }]);

  return TypeHandlerString;
}();

TypeHandlerString.TYPES = ['http://www.w3.org/2001/XMLSchema#string', 'http://www.w3.org/2001/XMLSchema#normalizedString', 'http://www.w3.org/2001/XMLSchema#anyURI', 'http://www.w3.org/2001/XMLSchema#base64Binary', 'http://www.w3.org/2001/XMLSchema#language', 'http://www.w3.org/2001/XMLSchema#Name', 'http://www.w3.org/2001/XMLSchema#NCName', 'http://www.w3.org/2001/XMLSchema#NMTOKEN', 'http://www.w3.org/2001/XMLSchema#token', 'http://www.w3.org/2001/XMLSchema#hexBinary', 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString'];
exports.TypeHandlerString = TypeHandlerString;